import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const RefreshIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.33342 12.9099C3.73928 11.9865 2.66675 10.2605 2.66675 8.28374C2.66675 6.04242 4.04553 4.12357 6.00008 3.3313M6.00008 11.2879L6.00008 13.9582H3.33342M10.6667 3.71234C12.2609 4.63576 13.3334 6.36171 13.3334 8.3385C13.3334 10.5798 11.9546 12.4987 10.0001 13.2909M10.0001 5.33439V2.66406L12.6667 2.66406"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

RefreshIcon.displayName = 'RefreshIcon';
